<script setup lang="ts">
import { capitalize } from 'lodash'
import { RouterLink } from 'vue-router'
import { VButton } from '@/modules/shared/components'
import VBadge from '@/modules/shared/components/VBadge.vue'
import CallDetailsWrapper from '@/modules/investing/components/entities/distributions/callDetailsWrapper.vue'
import DistributionDetailsWrapper from '@/modules/investing/components/entities/distributions/distributionDetailsWrapper.vue'

defineProps<{
  value: any
  isAdmin: boolean
  entityId: string
  entityType: string
  refetch: () => Promise<void>
}>()
</script>

<template>
  <div class="flex items-center justify-center">
    <RouterLink
      v-if="value?.kind === 'distribute' && isAdmin"
      :to="{
        name: 'investing.disbursement.new',
        params: { entity_type: entityType, entity_id: entityId },
        query: { portfolio_disbursement_allocation_id: value.pdaId },
      }"
    >
      <VButton size="xs"> Distribute </VButton>
    </RouterLink>
    <VBadge
      v-else-if="value?.kind === 'paid_count'"
      :color="value.paid === value.total ? 'V_PAID' : 'V_UNPAID'"
      :dot="false"
    >
      {{ value.paid }} / {{ value.total }} Paid
    </VBadge>
    <VBadge v-else-if="value?.kind === 'pending'" color="V_UNPAID" :dot="false"> Pending </VBadge>
    <VBadge
      v-else-if="value?.kind === 'capital_call_modal' && !value.invoiceId && !isAdmin && !value.isScheduled"
      :color="value.status === 'paid' ? 'V_PAID' : 'V_UNPAID'"
      :dot="false"
    >
      {{ capitalize(value.status) }}
    </VBadge>
    <CallDetailsWrapper
      v-else-if="value?.kind === 'capital_call_modal'"
      :callId="value.callId"
      :status="value.invoiceId ? capitalize(value.status) : null"
      :isAdmin="isAdmin"
      :isScheduled="value.isScheduled"
      :refetch="refetch"
    />
    <DistributionDetailsWrapper
      v-else-if="value?.kind === 'distribution_modal'"
      :distributionId="value.distributionId"
      :isAdmin="isAdmin"
      :refetch="refetch"
    >
      <template #default="{ fetchAndOpenModal }">
        <button @click="fetchAndOpenModal" class="focus:outline-none">
          <VBadge
            class="relative flex cursor-pointer items-center justify-center rounded-md border border-gray-200 bg-white px-2 py-1 shadow-sm transition-all hover:bg-gray-50 hover:shadow-md active:scale-[0.98]"
            :color="value.status === 'paid' ? 'V_DISTRIBUTION_RETURN_OF_CAPITAL' : 'V_UNPAID'"
            :dot="false"
          >
            {{ value.status === 'paid' ? 'Paid' : 'Unpaid' }}
          </VBadge>
        </button>
      </template>
    </DistributionDetailsWrapper>
    <VBadge v-else color="V_PAID" :dot="false"> Allocated </VBadge>
  </div>
</template>
